import { frameClass } from '../utils/style';
import { Link } from 'react-router-dom';
import { useProductSwipe } from '../hooks/useProductSwipe';

export default function ProductSlider({ products }) {
  const { swipeHandlers, currentIndex, currentProduct, total } = useProductSwipe(products);

  if (!Array.isArray(products) || products.length === 0 || !currentProduct) {
    return (
      <p className="text-center text-gray-500 mt-10">
        Belum ada properti tersedia.
      </p>
    );
  }

  const thumbnail =
    Array.isArray(currentProduct.images) && currentProduct.images.length > 0
      ? `https://prodmejatika.bljambi.com/public/products/${currentProduct.images[0].replace(/^products[\\/]+/, '')}`
      : null;

  const isBaru = (() => {
    try {
      return new Date() - new Date(currentProduct.created_at) < 7 * 24 * 60 * 60 * 1000;
    } catch {
      return false;
    }
  })();

  const isSoldOut = Number(currentProduct.stok) === 0;

  const openLiveChat = () => {
    window.open('https://wa.me/6281234567890?text=Halo, saya tertarik dengan properti serupa', '_blank');
  };

  return (
    <div className="px-4 py-4" {...swipeHandlers}>
      <p className="text-center text-sm text-gray-500 mb-2">
        👆 Geser kiri-kanan untuk lihat properti
      </p>

      <div className="transition-transform duration-500 ease-out">
        <div className={`${frameClass} mx-auto max-w-md overflow-hidden relative`}>
          {isBaru && (
            <span className="absolute top-2 left-2 bg-red-500 text-white text-xs px-2 py-0.5 rounded-full z-10">
              Baru 🎉
            </span>
          )}

          {thumbnail && (
            <img
              src={thumbnail}
              alt={currentProduct.title}
              className="w-full h-40 object-cover rounded-t"
              onError={(e) => (e.target.style.display = 'none')}
            />
          )}

          <div className="p-3">
            <h3 className="text-base font-semibold text-gray-800">{currentProduct.title}</h3>
            <p className="text-green-600 font-bold mt-1">
              {Number(currentProduct.price || 0).toFixed(7)} π
            </p>
            <p className="text-xs text-gray-500">{currentProduct.lokasi}</p>

            <div className="flex justify-between text-xs text-gray-600 mt-2">
              <span>Stok: {currentProduct.stok ?? 0}</span>
              <span>⭐ 5.0</span>
            </div>

            {isSoldOut ? (
              <div className="mt-3 text-sm text-red-600 bg-red-50 border border-red-200 p-2 rounded">
                <p className="font-semibold">Status: Terjual ✅</p>
                <p className="text-xs mt-1">
                  Unit ini sudah dibeli. Jika Anda ingin membeli properti serupa, silakan klik{' '}
                  <span className="underline text-blue-600 cursor-pointer" onClick={openLiveChat}>
                    Live Chat
                  </span>.
                </p>
              </div>
            ) : (
              <Link to={`/detail/${currentProduct.uuid}`}>
                <button className="mt-3 w-full bg-orange-500 text-white text-sm py-1 rounded hover:bg-orange-600 transition">
                  Lihat Detail
                </button>
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

